<template>
  <validation-observer v-slot="{ invalid }" ref="formRef" class="form form-sm mx-auto">
    <b-form v-loading="formProcessing" @submit.prevent="handleSubmit">
      <h2 class="mb-4 text-center">Change Password</h2>

      <div class="mb-4 text-sm lh-140">
        <p class="lh-140">
          In order to <strong class="font-weight-bold">protect your account</strong>, make
          sure your password:
        </p>
        <ul class="pl-3">
          <li
            v-for="restrictionsItem in restrictionsList"
            :key="restrictionsItem"
            class="mb-1"
          >
            {{ restrictionsItem }}
          </li>
        </ul>
      </div>

      <base-input
        v-model="formData.old_password"
        rules="required"
        name="Old Password"
        label="Old Password"
        type="password"
        payload-name="old_password"
      ></base-input>

      <base-input
        v-model="formData.new_password1"
        rules="required"
        vid="new_password1"
        data-vv-as="password"
        name="New Password"
        label="New Password"
        type="password"
        payload-name="new_password1"
      ></base-input>

      <base-input
        v-model="formData.new_password2"
        rules="required|confirmed:new_password1"
        name="Confirm New Password"
        label="Confirm New Password"
        type="password"
        payload-name="new_password2"
      ></base-input>

      <div class="mt-4 d-flex justify-content-between">
        <router-link
          :to="{ name: 'UserProfile' }"
          class="btn btn-md border-primary d-inline-flex align-items-center shadow-none"
          >Cancel</router-link
        >

        <base-button :disabled="invalid" type="primary" native-type="submit" size="md"
          >Change Password</base-button
        >
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import Vue from "vue";
import { defineComponent, reactive, ref } from "@vue/composition-api";

import { AuthenticationService } from "@services";

export default defineComponent({
  name: "FormChangePassword",
  setup() {
    const restrictionsList = [
      "Password cannot be similar to the email or username",
      "Password cannot be entirely numerical",
      "Password cannot be too common (i.e., password123)",
      "Password must have a minimum of 8 characters",
    ];

    const formData = reactive({});

    const formRef = ref();
    const formProcessing = ref(false);

    const handleSubmit = async () => {
      const res = await AuthenticationService.changePassword(
        formData.old_password,
        formData.new_password1,
        formData.new_password2
      ).catch((err) => {
        const error = err.response.data.data;

        if (error.token) Vue.prototype.$toasted.show("Invalid token.");
        else Vue.prototype.$bus.$emit("field-error", error);

        formProcessing.value = false;
      });

      if ("undefined" == typeof res) return;

      const data = res.data.data;

      Vue.prototype.$toasted.show(data.detail);

      formRef.value.reset();
      formProcessing.value = false;
    };

    return {
      restrictionsList,
      formData,
      formRef,
      formProcessing,
      handleSubmit,
    };
  },
});
</script>
